export const LOCAL_STORAGE_KEY = {
  ALGOLIA_QUERY_ID: 'algoliaQueryId',
}
